import { useState, useEffect } from 'react';

export const useCountAnimation = (endValue, duration = 1000, shouldAnimate, setShouldAnimate) => {
  const [count, setCount] = useState(endValue);
  
  useEffect(() => {
    if (!shouldAnimate) {
      setCount(endValue);
      return;
    }
    
    let startTimestamp = null;
    const startValue = count;
    
    const animate = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = timestamp - startTimestamp;
      
      const easeOutQuart = (x) => 1 - Math.pow(1 - x, 4);
      
      if (progress < duration) {
        const progressRatio = easeOutQuart(progress / duration);
        setCount(Math.round(startValue + (endValue - startValue) * progressRatio));
        requestAnimationFrame(animate);
      } else {
        setCount(endValue);
        setShouldAnimate(false);
      }
    };
    
    requestAnimationFrame(animate);
  }, [endValue, duration, shouldAnimate, setShouldAnimate, count]);
  
  return count;
}; 